module.exports = __webpack_public_path__ + "img/loading-transparent.e5f682e4.gif";